import { color, Text } from '@starrez/starryui9';
import React from 'react';
import styled from 'styled-components';
import { ShieldNegativeFlag } from '@starryui10/images/icons/ShieldNegativeFlag';
import { HStack } from '@starryui10/layouts/Stack';
import { strings } from '../localization';

export interface ISituationResponseLabelProps {
    count?: number;
}

export const SituationResponseLabel = ({ count }: ISituationResponseLabelProps) => {
    if (count && count > 0) {
        return (
            <SituationResponseLabelWrapper>
                <HStack gap="xxSmall" justifyContent="flex-start" align="center" height="100%">
                    <ShieldNegativeFlag color={color.Red.R60} />
                    <TextWrapper>
                        <Text color={color.Red.R80}>{`${count} ${
                            count === 1 ? strings.SituationResponseLabel_Label_Entry : strings.SituationResponseLabel_Label_Entries
                        } ${strings.SituationResponseLabel_Label_Context}`}</Text>
                    </TextWrapper>
                </HStack>
            </SituationResponseLabelWrapper>
        );
    } else {
        return <></>;
    }
};

const SituationResponseLabelWrapper = styled.span`
    height: 41px;
    padding: 0 12px;
    background: ${color.Red.R20};
    border-radius: 4px;
`;

// offset the line-height: 130% from Text
const TextWrapper = styled.span`
    padding-top: 2px;
`;
